module.exports = __webpack_public_path__ + "img/center front length.7aee63f1.png";